<template>
  <StyledTeamBadgeButton
    v-if="!isDraw"
    ref="badgeEl"
    :buttonId="buttonId"
    :disabled="disabled"
    :suspended="suspended"
    :isLeft="isLeft"
    :teamName="teamName || ''"
    :badgePath="competitor?.badge"
    :countryCode="competitor?.colors.country_code_a2"
    :isSelected="isSelected"
    :eventId="eventId"
    :homeOrAwayTeam="homeOrAwayTeam"
  />
  <StyledTeamTextButton
    v-else
    ref="badgeEl"
    :disabled="disabled"
    :buttonId="buttonId"
    :suspended="suspended"
    :teamName="drawText"
    :isSelected="isSelected"
  />
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import StyledTeamBadgeButton from "./styled/TeamBadgeButton.vue";
import StyledTeamTextButton from "./styled/TeamTextButton.vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { Option } from "@fresh8/types/src/betData";
import { getTranslation } from "@fresh8/ad-data-composition/src/lang";
import { SportCompetitor } from "@fresh8/types/src/betData";
import { AdTemplate, Brand } from "@fresh8/types/src";

export default defineComponent({
  name: "TeamBadgeButton",
  components: {
    StyledTeamBadgeButton,
    StyledTeamTextButton
  },
  props: {
    eventId: { type: String, required: true },
    isDraw: { type: Boolean, required: false, default: false },
    isLeft: { type: Boolean },
    option: { type: Object as PropType<Option | undefined>, required: true },
    competitor: {
      type: Object as PropType<SportCompetitor>,
      required: false,
      default: undefined
    },
    isSelected: { type: Boolean, required: false, default: false },
    homeOrAwayTeam: {
      type: String as PropType<"home" | "away">,
      default: "home",
      required: true
    }
  },
  setup(props) {
    const brandsContext = injectBrand() || ({} as BrandContext);

    const translations = getTranslation(
      window.navigator.language.toLowerCase()
    );

    const { targetEl: badgeEl } = composePopoverForm("Options Button", [
      {
        type: "button",
        get: () =>
          brandsContext?.brand.value?.adTemplate.parlayCard?.teamTextButton ||
          "",
        set: (value: string) => {
          if (brandsContext.brand.value?.adTemplate.parlayCard) {
            brandsContext.brand.value.adTemplate.parlayCard.teamTextButton = value;
          }
        }
      }
    ]);

    const buttonId = computed(
      () =>
        (brandsContext?.adTemplate.value as AdTemplate).parlayCard
          ?.teamTextButton as string
    );

    const teamName = computed(() => props?.competitor?.name?.micro);

    const drawText = computed(() => {
      return translations.ParlayTexts.Draw;
    });

    return {
      buttonId,
      disabled: !props.option || props.option?.suspended,
      suspended: props.option?.suspended,
      badgeEl,
      teamName,
      drawText
    };
  }
});
</script>
